export default [
  {
    name: 'Gain An Edge As You Build Your Roster With 64 Analytics',
    btnText: 'Get Started',
    btnPath: '/portal-pass',
  },
  {
    name: 'Set Up Notifications For Portal Players That Fit YOUR ROSTER',
    btnText: 'Get Started',
    btnPath: '/portal-pass',
  },
  {
    name: 'Softball America is proud to announce a partnership with @64analytics',
    btnText: 'Learn More',
    btnPath: 'https://x.com/SoftbalAmerica/status/1919762928708026765',
  },
  {
    name: 'Don’t fall behind during the transfer window',
    btnText: 'Get Transfer Portal Pass',
    btnPath: '/portal-pass',
  },
];
